export const close='close';export const refreshPage='refreshPage';